import type { SharedRoomDismissedMatch } from '@/hooks/useSharedRoomOffer'

const storageKey = (meetingId: string) => `ai-meeting:shared-room-rejoin:${meetingId}`

function canUseSessionStorage(): boolean {
  return typeof sessionStorage !== 'undefined'
}

/** Persist a Join-chip snapshot so reload still shows Tham gia (handoff 84 F5). */
export function saveSharedRoomRejoinSnapshot(
  meetingId: string,
  snapshot: SharedRoomDismissedMatch
): void {
  if (!canUseSessionStorage() || !meetingId) return
  try {
    sessionStorage.setItem(storageKey(meetingId), JSON.stringify(snapshot))
  } catch {
    // Quota / private mode — chip will not survive reload; live session still works.
  }
}

export function loadSharedRoomRejoinSnapshot(
  meetingId: string
): SharedRoomDismissedMatch | null {
  if (!canUseSessionStorage() || !meetingId) return null
  try {
    const raw = sessionStorage.getItem(storageKey(meetingId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as SharedRoomDismissedMatch
    if (parsed?.source !== 'declined' && parsed?.source !== 'left') return null
    if (!Array.isArray(parsed.peerNames)) return null
    if (parsed.source === 'left' && typeof parsed.roomId !== 'string') return null
    if (parsed.source === 'declined' && typeof parsed.matchId !== 'string') return null
    return {
      source: parsed.source,
      matchId: typeof parsed.matchId === 'string' ? parsed.matchId : undefined,
      roomId: typeof parsed.roomId === 'string' ? parsed.roomId : undefined,
      peerNames: parsed.peerNames.filter((name): name is string => typeof name === 'string'),
      meta: parsed.meta && typeof parsed.meta === 'object' ? parsed.meta : {},
    }
  } catch {
    return null
  }
}

export function clearSharedRoomRejoinSnapshot(meetingId: string): void {
  if (!canUseSessionStorage() || !meetingId) return
  try {
    sessionStorage.removeItem(storageKey(meetingId))
  } catch {
    // Ignore.
  }
}
